import "react";
import z from "../../../prop-types/index.js";
import J from "../../../react-clientside-effect/lib/index.es.js";
import { focusInside as g } from "../../../focus-lock/dist/es2015/focusInside.js";
import { focusIsHidden as K } from "../../../focus-lock/dist/es2015/focusIsHidden.js";
import { expandFocusableNodes as Q } from "../../../focus-lock/dist/es2015/focusables.js";
import { moveFocusInside as O } from "../../../focus-lock/dist/es2015/moveFocusInside.js";
import { captureFocusRestore as B } from "../../../focus-lock/dist/es2015/return-focus.js";
import { focusNextElement as U, focusPrevElement as X, focusFirstElement as Y, focusLastElement as Z } from "../../../focus-lock/dist/es2015/sibling.js";
import { getFocusableNodes as $ } from "../../../focus-lock/dist/es2015/utils/DOMutils.js";
import { deferAction as w, extractRef as k } from "./util.js";
import { mediumFocus as A, mediumBlur as _, mediumEffect as ee } from "./medium.js";
var H = function() {
  return document && document.activeElement === document.body;
}, oe = function() {
  return H() || K();
}, f = null, r = null, L = function() {
  return null;
}, l = null, p = !1, W = !1, ne = function() {
  return !0;
}, te = function(e) {
  return (f.whiteList || ne)(e);
}, re = function(e, o) {
  l = {
    observerNode: e,
    portaledElement: o
  };
}, ue = function(e) {
  return l && l.portaledElement === e;
};
function y(n, e, o, t) {
  var i = null, s = n;
  do {
    var d = t[s];
    if (d.guard)
      d.node.dataset.focusAutoGuard && (i = d);
    else if (d.lockItem) {
      if (s !== n)
        return;
      i = null;
    } else
      break;
  } while ((s += o) !== e);
  i && (i.node.tabIndex = 0);
}
var ie = function(e) {
  return e ? !!p : p === "meanwhile";
}, se = function n(e, o, t) {
  return o && (o.host === e && (!o.activeElement || t.contains(o.activeElement)) || o.parentNode && n(e, o.parentNode, t));
}, ce = function(e, o) {
  return o.some(function(t) {
    return se(e, t, t);
  });
}, N = function(e) {
  return $(e, /* @__PURE__ */ new Map());
}, ae = function(e) {
  return !N([e.parentNode]).some(function(o) {
    return o.node === e;
  });
}, h = function() {
  var e = !1;
  if (f) {
    var o = f, t = o.observed, i = o.persistentFocus, s = o.autoFocus, d = o.shards, M = o.crossFrame, T = o.focusOptions, D = o.noFocusGuards, b = t || l && l.portaledElement;
    if (H() && r && r !== document.body && (!document.body.contains(r) || ae(r))) {
      var I = L();
      I && I.focus();
    }
    var u = document && document.activeElement;
    if (b) {
      var m = [b].concat(d.map(k).filter(Boolean)), q = function() {
        if (!ie(M) || !D || !r || W)
          return !1;
        var c = N(m), F = c.findIndex(function(j) {
          var V = j.node;
          return V === r;
        });
        return F === 0 || F === c.length - 1;
      };
      if ((!u || te(u)) && (i || q() || !oe() || !r && s) && (b && !(g(m) || u && ce(u, m) || ue(u)) && (document && !r && u && !s ? (u.blur && u.blur(), document.body.focus()) : (e = O(m, r, {
        focusOptions: T
      }), l = {})), r = document && document.activeElement, r !== document.body && (L = B(r)), p = !1), document && u !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var C = document && document.activeElement, v = Q(m), E = v.map(function(a) {
          var c = a.node;
          return c;
        }).indexOf(C);
        E > -1 && (v.filter(function(a) {
          var c = a.guard, F = a.node;
          return c && F.dataset.focusAutoGuard;
        }).forEach(function(a) {
          var c = a.node;
          return c.removeAttribute("tabIndex");
        }), y(E, v.length, 1, v), y(E, -1, -1, v));
      }
    }
  }
  return e;
}, x = function(e) {
  h() && e && (e.stopPropagation(), e.preventDefault());
}, P = function() {
  return w(h);
}, de = function(e) {
  var o = e.target, t = e.currentTarget;
  t.contains(o) || re(t, o);
}, fe = function() {
  return null;
};
process.env.NODE_ENV !== "production" && z.node.isRequired;
var R = function() {
  W = !0;
}, G = function() {
  W = !1, p = "just", w(function() {
    p = "meanwhile";
  });
}, le = function() {
  document.addEventListener("focusin", x), document.addEventListener("focusout", P), window.addEventListener("focus", R), window.addEventListener("blur", G);
}, me = function() {
  document.removeEventListener("focusin", x), document.removeEventListener("focusout", P), window.removeEventListener("focus", R), window.removeEventListener("blur", G);
};
function ve(n) {
  return n.filter(function(e) {
    var o = e.disabled;
    return !o;
  });
}
var S = {
  moveFocusInside: O,
  focusInside: g,
  focusNextElement: U,
  focusPrevElement: X,
  focusFirstElement: Y,
  focusLastElement: Z,
  captureFocusRestore: B
};
function pe(n) {
  var e = n.slice(-1)[0];
  e && !f && le();
  var o = f, t = o && e && e.id === o.id;
  f = e, o && !t && (o.onDeactivation(), n.filter(function(i) {
    var s = i.id;
    return s === o.id;
  }).length || o.returnFocus(!e)), e ? (r = null, (!t || o.observed !== e.observed) && e.onActivation(S), h(), w(h)) : (me(), r = null);
}
A.assignSyncMedium(de);
_.assignMedium(P);
ee.assignMedium(function(n) {
  return n(S);
});
const Be = J(ve, pe)(fe);
export {
  Be as default
};
